import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
// import Axios from "axios";
//INCRIPTACION
// import CryptoJS from "crypto-js";

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  name: "Login",
  data() {
    return {
      loading: false,
      recovery: {
        cui: "",
        nit: "",
      }
    };
  },
  validations() {
    return {
      recovery: {
        cui: {
          required, min: minLength(1), max: maxLength(13)
        },
        nit: {
          required,
          max: maxLength(20)
        }
      }
    }
  },
  methods: {
    async auth() {
      this.loading = true;
      try {

        let r = await this.$store.state.services.loginService.putCambiarContrasena(this.recovery);
        //console.log("Login");
        if (r.data.success) {
          this.$toast.success("Se ha enviado un correo electrónico")
          let data = r.data.data
          console.log(data);
          this.loading = false;
          this.$router.push("/")
          this.recovery = {};
    
        } else {
          this.loading = false;
          this.$toast.error("Error ocurrió un problema en la recuperación de contraseña")
        }
      } catch (error) {
        this.loading = false;
        this.$toast.error("Error ocurrió un problema en la recuperación de contraseña")
      }

    }
  },
};